import { createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'
import { ResellerEditPage } from '@/features/resellers-admin/pages/reseller-edit'

export const Route = createFileRoute('/_authenticated/resellers/$resellerId')({
  beforeLoad: requireRole('admin'),
  component: function ResellerEditRoute() {
    const { resellerId } = Route.useParams()
    return <ResellerEditPage resellerId={resellerId} />
  },
})
